module.exports = __webpack_public_path__ + "static/media/f7.2fce9c3e.jpg";